import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { WhiteSpaceValidator } from 'src/app/validators/white-space.validator';
import { AdminRequestDto, AdminResponseDto, AdminService, NotificationDto, NotificationService } from 'src/generated_client';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  notificationForm: FormGroup = this.fb.group({
    title: ['', Validators.compose([Validators.required, WhiteSpaceValidator.cannotContainSpace])],
    description:['',Validators.compose([Validators.required, Validators.maxLength(250), WhiteSpaceValidator.cannotContainSpace])],
    password: ['', Validators.required]
  })

  notification: NotificationDto = {} as NotificationDto;
  adminRequest : AdminRequestDto = {} as AdminRequestDto;
  adminResponse: AdminResponseDto = {} as AdminResponseDto;

    constructor(
      private fb: FormBuilder,
      private notificationService : NotificationService,
      private authService:  AuthService,
      private adminService: AdminService,
      private router: Router,
      private snackBar : SnackBarService
    ) { }

  ngOnInit(): void {
    this.adminResponse = this.authService.currentUser();

  }


  saveChanges(form:any){
    this.adminRequest = {dsUsername: String(this.adminResponse.dsUsername), dsPassword: form.password}
    let result = this.adminService.apiAdminConfirmPost(this.adminRequest).subscribe(response=>{
      if(result){
        this.notification = {
                title: form.title,
                content: form.description
              }
              this.notificationService.apiNotificationPushNotificationPost(this.notification).subscribe(response=>{
                this.router.navigate(['admin-home']);
                this.snackBar.openSnackBar('La notificación fue enviada','Aceptar');
                this.notificationForm.reset();
              }, err=>{
                this.snackBar.openSnackBar(err.error.error,"Aceptar");
              })
      }
    }, err =>{
      this.snackBar.openSnackBar(err.error.error,'Aceptar')
    });
  }
      
}
  

